export const AUTH_COOKIE_NAME = 'Jwt';
export const LEAD_COOKIE_NAME = 'fff_lead_uuid';
export const OPTIMIZELY_ANON_ID_COOKIE_NAME = 'maui_optimizely_anon_id';
/** Anonymous ID shared by maui and the CRA apps, so LD gets the same key on every surface. */
export const FFF_ANON_ID_COOKIE_NAME = 'fff_anon_id';
